import { render, staticRenderFns } from "./OffRoad.vue?vue&type=template&id=34fa669a&scoped=true"
import script from "./OffRoad.vue?vue&type=script&lang=js"
export * from "./OffRoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa669a",
  null
  
)

export default component.exports